import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useTranslations } from 'js/hooks/i18n';
import { setPlayerTags } from 'js/hooks/user/server';
import { useGetErrorResponseMessage } from 'js/hooks/server';
import { useShowNotification } from 'js/components/common/Notifications';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { prepareTags } from '../helpers';

export const useUpdatePreferences = ({ initialValues, refetch, setSubmitError }) => {
    const showNotification = useShowNotification();
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const t = useTranslations('playtech.mobile.system.2FA.preferences.');

    return useCallback((formData) => {
        const tags = prepareTags(formData, initialValues);

        if (tags.length === 0) {
            setSubmitError(t('save.noChanges'));

            return;
        }

        const updateTags = async () => {
            await setPlayerTags(tags);
            showNotification({ message: t('save.success') });
            refetch(Date.now());
        };

        (async () => {
            try {
                setSubmitError();
                await updateTags();
            } catch (error) {
                const { data = {} } = error?.response || error || {};

                if (data.errorCode === 303) {
                    dispatcher.dispatch('app:message', {
                        ID: 'twoFactorAuthentication',
                        data: {
                            onCancel: () => {
                                publicEventsAPIService.trigger('2fa-popup-closed', 'change-2fa-preferences');
                            },
                            onSuccess: updateTags,
                            resendHandler: () => setPlayerTags(tags)
                        }
                    });

                    return;
                }

                setSubmitError(getErrorResponseMessage(error));
            }
        })();
    }, [initialValues, refetch, setSubmitError, showNotification, getErrorResponseMessage, t]);
};
